import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const Navbar = ({ firstTitle, secondTitle }) => {
  return (
    <nav className='navbar navbar-expand-sm navbar-dark bg-dark'>
      <div className='container'>
        <Link className='navbar-brand' to='/'>
          {firstTitle}
          <b style={logoStyle}>{secondTitle}</b>
        </Link>
        <button
          className='navbar-toggler'
          type='button'
          data-toggle='collapse'
          data-target='#navbarCollapse'
        >
          <span className='navbar-toggler-icon'></span>
        </button>
        <div className='collapse navbar-collapse' id='navbarCollapse'>
          <ul className='navbar-nav ml-auto'>
            <li className='nav-item'>
              <Link className='nav-link' to='/'>
                Home<i className='fas fa-home' style={iconsStyle}></i>
              </Link>
            </li>
            <li className='nav-item'>
              <Link className='nav-link' to='/search'>
                Search<i className='fas fa-search' style={iconsStyle}></i>
              </Link>
            </li>
            <li className='nav-item'>
              <Link className='nav-link' to='/about'>
                About<i className='fas fa-book-open' style={iconsStyle}></i>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

Navbar.defaultProps = {
  firstTitle: 'Lopp',
  secondTitle: 'Med'
};
Navbar.propTypes = {
  firstTitle: PropTypes.string.isRequired,
  secondTitle: PropTypes.string.isRequired
};

const logoStyle = {
  color: '#cd5c5c'
};

const iconsStyle = {
  marginLeft: '5px',
  fontSize: '16px'
};

export default Navbar;
